var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "POS",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3b4e}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3 0H16.7A16.7 16.7 0 0 0 0 16.7v66.6A16.7 16.7 0 0 0 16.7 100h66.6A16.7 16.7 0 0 0 100 83.3V16.7A16.7 16.7 0 0 0 83.3 0zm-1.5 76.6a5.3 5.3 0 0 1-5.3 5.3h-53a5.3 5.3 0 0 1-5.3-5.3V23.5a5.3 5.3 0 0 1 5.3-5.3h53a5.3 5.3 0 0 1 5.3 5.3v53.1z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4 63.6a3 3 0 0 1-3-3V39.4a3 3 0 0 1 3-3h21.2a3 3 0 0 1 3 3v21.2a3 3 0 0 1-3 3H39.4z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo);
export default __webpack_public_path__ + "static/media/squareLogo.563f166fd8cb4fb56867fcc540dab1ad.svg";
export { ForwardRef as ReactComponent };